export default __webpack_public_path__ + "static/media/zulip.0e03504d.svg";